import { Injectable } from '@angular/core';
import { studentNavigationConfigs } from '@services/navigation/student-navigation-configs';

import { NavigationService } from './navigation.service';

@Injectable()
export class StudentNavigationService extends NavigationService {
  navigationConfigs = studentNavigationConfigs;
}
